/**
 * PaymentMethod DTO exposed by payment-service `/api/payment-methods`.
 * Mirrors `net.nawam.payment.model.entity.PaymentMethod`.
 */

export type PaymentMethodType = 'WALLET' | 'CARD' | 'CASH';

export interface PaymentMethod {
  // ── BaseEntity ───────────────────────────────────────────────────────
  id: number;
  createdAt?: string | null;
  updatedAt?: string | null;
  /** BaseEntity boolean flag — active when true. Distinct from `deleted`. */
  status?: boolean;
  deleted?: boolean;

  // ── domain ────────────────────────────────────────────────────────────
  name: string;
  /** Unique vendor identifier (e.g. `WAVE_SN_API_CASH_IN`). */
  serviceCode: string;
  imageUrl?: string | null;
  type: PaymentMethodType;
}

/** Body of `POST /api/payment-methods` and `PUT /api/payment-methods/{id}`.
 *  The back uses the same shape as the entity (no dedicated DTO), so we
 *  reuse `PaymentMethod` minus the read-only fields. */
export interface PaymentMethodWriteRequest {
  name: string;
  serviceCode: string;
  imageUrl?: string | null;
  type: PaymentMethodType;
}

export const PAYMENT_METHOD_TYPE_LABEL: Record<PaymentMethodType, string> = {
  WALLET: 'Wallet mobile',
  CARD: 'Carte bancaire',
  CASH: 'Espèces',
};
